import { adaloBackendAxios } from './io/http/axios'

export const getBuildLogs = async (
  appId: string,
  buildId: string
): Promise<string> => {
  return (await adaloBackendAxios.get(`/apps/${appId}/builds/${buildId}/logs`))
    .data as string
}
